import { createLocale, dateUzUZ, uzUZ } from 'naive-ui';
import { toNewLatin } from '@kitobxonlik/contracts';

function latinize<T>(value: T): T {
  if (typeof value === 'string') return toNewLatin(value) as T;
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, latinize(item)]),
    ) as T;
  }
  return value;
}

/**
 * Naive UI'ning o'z matnlari (bo'sh maydon placeholder'i, sana tanlagich,
 * «ma'lumot yo'q» va h.k.). Avval `enUS` edi — maydonlarda «Please Input» /
 * «Please Select» chiqardi. Naive'ning `uzUZ` asos qilingan, lekin unda tutuq
 * belgisi o'rniga backtick (`Ma\`lumotlar yo\`q`) va bir nechta noto'g'ri
 * tarjima bor — shular shu yerda tuzatiladi. Qolgan matnlari eski imloda
 * (`Tozalash`) — `latinize` yangisiga o'tkazadi (format satrlarida `sh`/`ch` yo'q).
 */
export const naiveLocale = latinize(
  createLocale(
    {
      Cascader: { placeholder: 'Tanlang' },
      Select: { placeholder: 'Tanlang' },
      Input: { placeholder: 'Kiriting' },
      InputNumber: { placeholder: 'Kiriting' },
      TimePicker: { placeholder: 'Vaqtni tanlang' },
      DatePicker: {
        selectTime: 'Vaqtni tanlang',
        selectDate: 'Sanani tanlang',
        datePlaceholder: 'Sanani tanlang',
        datetimePlaceholder: 'Sana va vaqtni tanlang',
        monthPlaceholder: 'Oyni tanlang',
        yearPlaceholder: 'Yilni tanlang',
        quarterPlaceholder: 'Çorakni tanlang',
        weekPlaceholder: 'Haftani tanlang',
        startDatePlaceholder: 'Boşlanğiç sana',
        endDatePlaceholder: 'Tugaş sanasi',
        startDatetimePlaceholder: 'Boşlanğiç sana va vaqt',
        endDatetimePlaceholder: 'Tugaş sanasi va vaqti',
        startMonthPlaceholder: 'Boşlanğiç oy',
        endMonthPlaceholder: 'Tugaş oyi',
      },
      Empty: { description: 'Ma’lumot yöq' },
      Pagination: { goto: 'Ötiş' },
      DynamicTags: { add: 'Qöşiş' },
      Image: {
        tipCounterclockwise: 'Soat miliga teskari',
        tipClockwise: 'Soat mili böyiça',
        tipZoomOut: 'Kiçraytiriş',
        tipZoomIn: 'Kattalaştiriş',
        tipOriginalSize: 'Asl ölçamga qaytiş',
      },
    },
    uzUZ,
  ),
);

const { locale: dateFnsUz } = dateUzUZ;

/** Sana tanlagichdagi kun nomlari — `date-fns` lokalidan eski imloda (`Cho`, `Sha`) keladi */
export const naiveDateLocale: typeof dateUzUZ = {
  ...dateUzUZ,
  locale: {
    ...dateFnsUz,
    localize: {
      ...dateFnsUz.localize,
      day: (...args) => toNewLatin(dateFnsUz.localize.day(...args)),
    },
  },
};
